<template>
  <a-form
    ref="formRef"
    layout="vertical"
    :model="form"
    class="form"
  >
    <a-form-item
      :label="$t('weekly.risk')"
      name="currentRisk"
      :rules="{
        type: 'string',
      }"
    >
      <a-textarea
        v-model:value="form.currentRiskToEdit"
        :placeholder="$t('okr.personalObjective.placeholder')"
        :auto-size="{ minRows: 6, maxRows: 6 }"
      />
    </a-form-item>
  </a-form>
  <FormAction
    :loading="loading"
    :can-close="false"
    @cancel="emit('cancel')"
    @save="onSave()"
  />
</template>
<script setup>
import { ref, toRefs, defineEmits, unref } from 'vue'
import FormAction from '@/views/OkrList/FormAction.vue'
import { editOkrWeeklyRisk } from '@/api/weekly'
import { message } from 'ant-design-vue'
import { useI18n } from 'vue-i18n'
const emit = defineEmits(['cancel'])
const props = defineProps({
  weekData: {
    type: Object,
    default: () => {}
  },
  updateWeekRisk: {
    type: Function,
    default: () => {}
  }
})
const { t } = useI18n()
const { updateWeekRisk } = toRefs(props)
const form = unref(ref(JSON.parse(JSON.stringify(props.weekData))))
const formRef = ref()

const loading = ref(false)
const onSave = async () => {
  loading.value = true
  try {
    await formRef.value.validate()
  } catch (_) {
    loading.value = false
    return
  }
  const params = {
    id: form.id,
    current_risk: form.currentRiskToEdit,
    objective_id: form.objectiveId,
    keyresult_id: form.keyresultId,
    okrlist_id: form.okrlistId,
    week_date: form.weekDate
  }
  editOkrWeeklyRisk(params).then(res => {
    loading.value = false
    updateWeekRisk.value(form.currentRiskToEdit)
    emit('cancel')
    message.success(t('weekly.editSuccess'))
  })
}
</script>
